import React from "react";
import ChatItem from "./ChatItem";

const ChatList = ({ chats, onSelectChat }) => {
  return (
    <div className="w-96 border-r border-gray-200 p-4">
      <div className="flex items-center justify-between mb-3 border-b-2 border-[#095228] pb-4">
        <h3 className="text-2xl text-[#000000] font-semibold">Chats</h3>
        <span className="bg-[#095228] text-white text-xs px-3 py-2 rounded-full font-bold">
          {chats.length}
        </span>
      </div>

      {/* Search Friend */}
      {/* Search Friend */}
      <div className="relative w-full mb-4">
        <input
          type="text"
          placeholder="Find Your Friend"
          className="w-full pl-10 pr-4 py-4 text-sm text-[#B8B8B8] border-none rounded-full outline-none focus:ring-2 focus:ring-green-500 bg-[#F0F0F0]"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="absolute left-3 top-1/2 -translate-y-1/2 text-[#B8B8B8]"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.7838 2.91699C5.99797 2.91699 2.91797 5.99616 2.91797 9.78199C2.91797 13.5678 5.99797 16.6478 9.7838 16.6478C13.5688 16.6478 16.6488 13.5678 16.6488 9.78199C16.6488 5.99616 13.5688 2.91699 9.7838 2.91699ZM9.7838 17.8978C5.3088 17.8978 1.66797 14.257 1.66797 9.78199C1.66797 5.30699 5.3088 1.66699 9.7838 1.66699C14.2588 1.66699 17.8988 5.30699 17.8988 9.78199C17.8988 14.257 14.2588 17.8978 9.7838 17.8978Z"
            fill="#B8B8B8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9291 18.9348C17.7699 18.9348 17.6099 18.874 17.4874 18.7523L14.5507 15.824C14.3066 15.5798 14.3057 15.184 14.5499 14.9398C14.7932 14.694 15.1891 14.6957 15.4341 14.9382L18.3707 17.8673C18.6149 18.1115 18.6157 18.5065 18.3716 18.7507C18.2499 18.874 18.0891 18.9348 17.9291 18.9348Z"
            fill="#B8B8B8"
          />
        </svg>
      </div>

      {chats.map((chat) => (
        <ChatItem
          key={chat.id}
          chat={chat}
          onClick={() => onSelectChat(chat)}
        />
      ))}
    </div>
  );
};

export default ChatList;
